module.exports = __webpack_public_path__ + "img/avatar-7.57d546e2.jpg";